import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdPresetBannerTemplatesResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      description: string,
      last_edited_at: number,
      template_id: string,
      sort_order: number,
      html: string,
    })
  ),
});
